<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title>
        {{ $t('barcode') }}  {{ $t('product') }}
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="openUploadDialog"
          >
            <v-icon
              color="deep-orange"
              style="font-size: 22px"
            >
              mdi-database-import-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('importData') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-container>
      <v-row style="max-height: 170px;border-bottom: 1px solid #e3e3e3">
        <v-col
          cols="12"
          md="2"
          class="pb-0"
          style="height: 45px"
        >
          <v-text-field
            v-model="width"
            :label="$t('widthRoll')"
            height="20"
            dense
            outlined
            class="mb-1 dense"
            clearable
          />
        </v-col>
        <v-col
          cols="12"
          md="2"
          class="pb-0"
          style="height: 45px"
        >
          <v-text-field
            v-model="height"
            :label="$t('heightLabel')"
            height="20"
            dense
            outlined
            class="mb-1 dense"
            clearable
          />
        </v-col>
        <v-col
          cols="6"
          md="2"
          class="pb-0"
          style="height: 45px"
        >
          <v-text-field
            v-model="columns"
            :label="$t('countLabelRow')"
            height="20"
            dense
            type="number"
            outlined
            class="mb-1 dense"
            clearable
          />
        </v-col>
        <v-col
          cols="6"
          md="2"
          class="pb-0"
          style="height: 45px"
        >
          <v-text-field
            v-model="barcodeHeight"
            :label="$t('barcodeHeight')"
            height="20"
            dense
            type="number"
            outlined
            class="mb-1 dense"
            clearable
          />
        </v-col>
        <v-col
          cols="6"
          md="2"
          class="pb-0"
          style="height: 45px"
        >
          <v-text-field
            v-model="marginX"
            :label="$t('marginX')"
            height="20"
            dense
            type="number"
            outlined
            class="mb-1 dense"
            clearable
          />
        </v-col>
        <v-col
          cols="6"
          md="2"
          class="pb-0"
          style="height: 45px"
        >
          <v-text-field
            v-model="padding"
            :label="$t('padding') + '(px)'"
            height="20"
            dense
            type="number"
            outlined
            class="mb-1 dense"
            clearable
          />
        </v-col>
        <v-col
          cols="6"
          md="2"
          class="pb-0"
          style="height: 45px"
        >
          <v-text-field
            v-model="paddingRight"
            :label="$t('padding-right') + '(px)'"
            height="20"
            dense
            type="number"
            outlined
            class="mb-1 dense"
            clearable
          />
        </v-col>
        <v-col
          cols="6"
          md="2"
          class="pb-0"
          style="height: 45px"
        >
          <v-text-field
            v-model="paddingTop"
            :label="$t('padding-top') + '(px)'"
            height="20"
            dense
            type="number"
            outlined
            class="mb-1 dense"
            clearable
          />
        </v-col>
        <v-col
          cols="6"
          md="2"
          class="pb-0"
          style="height: 45px"
        >
          <v-checkbox
            v-model="showBarcode"
            class="mt-0 mx-0"
            :label="$t('showBarcode')"
            value="active"
          />
        </v-col>
        <v-col
          cols="6"
          md="2"
          class="pb-0"
          style="height: 45px"
        >
          <v-checkbox
            v-model="showName"
            class="mt-0 mx-0"
            :label="$t('showName')"
            value="active"
          />
        </v-col>
        <v-col
          cols="6"
          md="2"
          class="pb-0"
          style="height: 45px"
        >
          <v-checkbox
            v-model="showPrice"
            class="mt-0 mx-0"
            :label="$t('showPrice')"
            value="active"
          />
        </v-col>
        <v-col
          cols="6"
          md="2"
          class="pb-0"
          style="height: 45px"
        >
          <v-checkbox
            v-model="showUnit"
            class="mt-0 mx-0"
            :label="$t('showUnit')"
            value="active"
          />
        </v-col>
        <v-col
          cols="12"
          md="2"
          class="pb-0"
          style="height: 45px"
        >
          <v-btn
            color="primary"
            class="mr-0"
            small
            @click="print"
          >
            {{ $t('print') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          :style="{'height': tableHeight + 'px'}"
          style="overflow-y: auto"
        >
          <div id="print">
            <div
              :style="{'width': width, 'height': height}"
              class="d-flex"
            >
              <v-row
                style="margin-top: 1px;margin-right: 0px !important;margin-left: 0px !important;"
              >
                <v-col
                  v-for="(item, i) in barcodeItems"
                  :key="i"
                  :cols="12/columns"
                  class="my-0 justify-center"
                  :style="{'height': height, 'padding' : padding + 'px', 'padding-right': paddingRight + 'px', 'padding-top': paddingTop + 'px', 'margin-right': marginX + 'px !important', 'margin-left': marginX + 'px !important'}"
                >
                  <img
                    v-show="item.code && showBarcode"
                    width="100%"
                    class="barcode"
                    :height="barcodeHeight + '%'"
                    :jsbarcode-value="item.code"
                    jsbarcode-textmargin="0"
                    jsbarcode-fontoptions="bold"
                  >
                  <p
                    v-if="showName"
                    class="pa-0 text-center ma-0"
                    :style="{'margin-top': (item.code && showBarcode ? '-10px !important' : 'opx')}"
                    style="font-size: 80%;text-align: center"
                  >
                    {{ item.name }}
                  </p>
                  <p
                    v-if="item.price && showPrice"
                    class="pa-0 text-center ma-0"
                    style="font-size: 12px;text-align: center"
                  >
                    {{ $t('price') }}:{{ $numberFormat(parseFloat(item.price)) }} {{ $store.state.currencySymbol }}
                  </p>
                  <p
                    v-if="item.unit && showUnit"
                    class="pa-0 text-center ma-0"
                    style="font-size: 10px;text-align: center"
                  >
                    {{ $t('unit') }}:{{ (item.unit ? item.unit.fame : '') }}
                  </p>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-dialog
        v-model="uploadDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        width="500"
      >
        <v-card>
          <v-col>
            <v-btn
              icon
              class="close-hover"
              @click="uploadDialog = false"
            >
              <v-icon
                color="grey"
                large
              >
                mdi-close
              </v-icon>
            </v-btn>
          </v-col>
          <v-col
            class="mt-0 pt-0 pr-7"
          >
            <upload
              type-prop="barcode"
              :get-item="uploadDialog"
              @close="uploadDialog=false"
              @input="getItems"
            />
          </v-col>
          <v-card-actions>
            <v-row class="ma-0" />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-card>
</template>

<script>
import Upload from '../../components/general/upload/upload'
export default {
  name: 'Barcode',
  props: ['items'],
  components: {
    Upload
  },
  data () {
    return {
      printType: 'unofficial',
      width: '4.45in',
      height: '1in',
      marginX: 0,
      divHeight: 400,
      columns: 3,
      barcodeHeight: 50,
      paddingTop: 0,
      paddingRight: 0,
      padding: 4,
      showBarcode: 'active',
      showName: 'active',
      showUnit: 'active',
      showPrice: 'active',
      uploadDialog: false,
      barcodeItems: []
    }
  },
  watch: {
    width () { localStorage.setItem('barcode-options', JSON.stringify(this.$data)) },
    height () { localStorage.setItem('barcode-options', JSON.stringify(this.$data)) },
    columns () { localStorage.setItem('barcode-options', JSON.stringify(this.$data)) },
    padding () { localStorage.setItem('barcode-options', JSON.stringify(this.$data)) },
    showPrice () { localStorage.setItem('barcode-options', JSON.stringify(this.$data)) },
    showName () { localStorage.setItem('barcode-options', JSON.stringify(this.$data)) },
    showUnit () { localStorage.setItem('barcode-options', JSON.stringify(this.$data)) },
    paddingRight () { localStorage.setItem('barcode-options', JSON.stringify(this.$data)) },
    paddingTop () { localStorage.setItem('barcode-options', JSON.stringify(this.$data)) },
    showBarcode (val) {
      if (val) {
        this.barcodeGenerate()
      }
      localStorage.setItem('barcode-options', JSON.stringify(this.$data))
    },
    items (val) {
      this.barcodeItems = val
      if (this.barcodeItems) {
        this.barcodeGenerate()
      }
    }
  },
  mounted () {
    var barcode = document.createElement('script')
    barcode.setAttribute('src', 'https://abr.abriron.com/js/JsBarcode.all.min.js')
    document.head.appendChild(barcode)
    var app = this
    app.barcodeItems = app.items
    setTimeout(function () {
      if (app.barcodeItems) {
        app.barcodeGenerate()
      }
    }, 1000)
    this.getOptions()
  },
  methods: {
    getItems (items) {
      var app = this
      app.barcodeItems = items
      setTimeout(function () {
        app.barcodeGenerate()
      }, 1000)
    },
    openUploadDialog () {
      this.uploadDialog = true
    },
    getOptions () {
      var option = JSON.parse(localStorage.getItem('barcode-options'))
      if (option) {
        this.width = option.width
        this.height = option.height
        this.padding = option.padding
        this.columns = option.columns
        this.showBarcode = option.showBarcode
        this.showUnit = option.showUnit
        this.showName = option.showName
        this.showPrice = option.showPrice
        this.paddingRight = option.paddingRight
        this.paddingTop = option.paddingTop
      } else {
        localStorage.setItem('barcode-options', JSON.stringify(this.$data))
      }
    },
    barcodeGenerate () {
      window.JsBarcode('.barcode').options({ displayValue: true }).init()
    },
    print () {
      var direction = 'ltr'
      if (this.$vuetify.rtl) {
        direction = 'rtl'
      }
      var style = '<style>' +
          '' + (this.$store.state.lang !== 'fa' ? 'body {font-family: arial !important;}' : '') +
          '@page {size: ' + this.width + ' ' + this.height + ';margin: 0;}' +
          '@media print {html, body {width: ' + this.width + ';height: ' + this.height + ';}}' +
          'table { border: none; border-collapse: collapse; }' +
          'table td { border-left: 1px solid #c3c3c3; }' +
          'table th { border-left: 1px solid #c3c3c3; }' +
          'table td:first-child { border-right: 1px solid #c3c3c3;  }' +
          'table th:first-child { border-right: 1px solid #c3c3c3;  }' +
          'tbody > tr:last-child > td {border: 0px;}' +
          'thead > tr:first-child > th { border-top: 1px solid #c3c3c3; }' +
          '@bottom-left {content: normal;margin: 3px;}' +
          '</style>'
      setTimeout(function () {
        // Get HTML to print from element
        const prtHtml = document.getElementById('print').innerHTML

        let stylesHtml = ''
        let node = null
        for (node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
          stylesHtml += node.outerHTML
        }

        const WinPrint = window.open('', '', 'left=0,top=0,width=1100,height=900,toolbar=0,scrollbars=0,status=0')
        WinPrint.document.write('<!DOCTYPE html> <html> <head> ' + stylesHtml + ' ' + style + ' </head> <body style="direction: ' + direction + '">' + prtHtml + ' </body> </html>')
        WinPrint.document.close()
        WinPrint.focus()
        setTimeout(function () {
          WinPrint.print()
          WinPrint.close()
        }, 2000)
      }, 50)
    }
  }
}
</script>

<style scoped>

</style>
